module.exports = __webpack_public_path__ + "img/20191019154215360截图20191019144938532.0642ed75.jpg";